/* eslint-disable import/prefer-default-export */
import memoize from 'lodash.memoize';
import { NODE_ENV } from './public-config';

const shouldEnableAnalytics = memoize(() => {
  // disable analytics for Cypress tests
  if (typeof window !== 'undefined' && (window as any)?.Cypress) {
    return false;
  }
  // enable analytics if it is PRODUCTION or if we set ENABLE_ANALYTICS env var
  return NODE_ENV === 'production' || !!process.env.ENABLE_ANALYTICS;
});

const isLaunchDarklyEnabled = (route?: string) => {
  if (!route) {
    return true; // Set this to "true" to re-enable LaunchDarkly on the server
  }

  // list of routes to include in LaunchDarkly
  const routeIncludeList = ['/platform-configurator'];

  return routeIncludeList.includes(route);
};

export { shouldEnableAnalytics, isLaunchDarklyEnabled };
